import React, { Component } from 'react'
import { connect } from 'react-redux'
import { IconButton } from '@material-ui/core'
import { ShoppingCartOutlined } from '@material-ui/icons'
import { withRouter } from 'react-router-dom';
import './style.scss'
import LinkItem from '../LinkItem';
import Search from '../Search';
import RoundButton from '../RoundButton';
class Header extends Component {
  confirmLogin = () => {
    window.location.href = '/cartspage'
    // this.props.history.push('/cartspage')
  }
  render() {
    return (
      <div className="page-header">
        {/* <div className="greeting">Boa tarde 116 Guarapari(Es)! Sexta-feira, 28 de Agosto de 2020</div>
        <div className="description">Pedidos comprados para recebimento om Outubro de 2020(Fechado)</div>
        <TextField
          select
        >
          <MenuItem value={1}>Seleciono o periodo</MenuItem>
        </TextField> */}
        <div className="logo" style={{ backgroundImage: `url(${require('../../assets/images/logoimage.png')}` }}>
          {/* <img src={require('../../assets/images/logo.png')} alt="" /> */}
        </div>
        <div className="menu-content">
          <div className="item-lists">
            <div className="menu-bar">
              <LinkItem text="Home" active />
              <LinkItem text="Bolsas" />
              <LinkItem text="Sapatos" />
              <LinkItem text="Acessórios" />
              <LinkItem text="Vitrine" />
            </div>
            <div className="search-content">
              <Search />
              {/* <IconButton ><SearchOutlined /></IconButton>
            <IconButton ><AccountCircleOutlined /></IconButton>
            <IconButton onClick={this.confirmLogin}>
              <ShoppingCartOutlined />
            </IconButton> */}
            </div>
          </div>
          <IconButton onClick={this.confirmLogin}>
            <ShoppingCartOutlined />
          </IconButton>
          <RoundButton>Minha Conta</RoundButton>
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => ({
})


export default withRouter(connect(mapStateToProps, {
})(Header))
